module.exports = __webpack_public_path__ + "static/travel-to-the-moon-425dcf24d4918fe9e6c95c2de78b9c18.svg";